var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.00002V19.91C11.25 20.62 10.53 21.11 9.88 20.84C8.02 20.06 5.71 19.38 4.07 19.16L3.76 19.12C2.79 19 2 18.11 2 17.14V5.25002C2 4.05002 2.97 3.08002 4.17 3.08002H4.24C6.12 3.24002 8.89 4.12002 10.72 5.11002C11.05 5.29002 11.25 5.62002 11.25 6.00002Z",
    fill: "#0082CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.83 3.08002H19.77C19.53 3.10002 19.27 3.13002 19 3.18002C17.77 3.38002 16.31 3.80002 15 4.32002C14.38 4.57002 13.8 4.84002 13.29 5.11002C12.96 5.29002 12.75 5.63002 12.75 6.00002V19.91C12.75 20.62 13.47 21.11 14.12 20.84C15.98 20.06 18.29 19.38 19.93 19.16L20.24 19.12C21.21 19 22 18.11 22 17.14V5.25002C22 4.05002 21.03 3.08002 19.83 3.08002ZM19.27 11.33C19.27 11.72 18.99 11.89 18.65 11.7L17.59 11.11C17.48 11.05 17.3 11.05 17.18 11.11L16.12 11.7C15.78 11.89 15.5 11.72 15.5 11.33C15.5 11.33 15.5 7.70622 15.5 6.95443C15.5 6.20265 16.2 5.99974 16.2 5.99974C16.2 5.99974 16.9441 5.70578 18 5.39974C19 5.10991 19.27 5.59619 19.28 5.86002L19.27 11.33Z",
    fill: "#0082CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.caf0e8e0aab2facfa9cfb093be11f6e4.svg";
export { ForwardRef as ReactComponent };